import { useApi } from '../hooks.js'
import { RANGES } from '../hooks.js'

/**
 * Every page's title bar, with the shared period and department filters.
 *
 * One component rather than a heading rolled per page: the M13 audit measured six hand-written section-header
 * variants on Android, four of them byte-identical, because there was no shared one to reach for. Starting the
 * console with this avoids repeating that.
 *
 * The department list is read from the fleet rather than hard-coded — a plant that adds a department should not
 * need a front-end release for it to appear in the filter.
 */
export default function PageHeader({ title, subtitle, range, actions }) {
  const departments = useApi('/assets', { skip: !range })

  const options = departments.data
    ? [...new Set(departments.data.map((a) => a.department).filter(Boolean))].sort()
    : []

  return (
    <header className="page-head">
      <div>
        <h1>{title}</h1>
        {subtitle && <p className="muted">{subtitle}</p>}
      </div>

      <div className="page-controls">
        {actions}
        {range && (
          <>
            <select
              aria-label="Department"
              value={range.department}
              onChange={(e) => range.setDepartment(e.target.value)}
            >
              <option value="">All departments</option>
              {options.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
            <select aria-label="Period" value={range.key} onChange={(e) => range.setKey(e.target.value)}>
              {RANGES.map((r) => <option key={r.key} value={r.key}>{r.label}</option>)}
            </select>
          </>
        )}
      </div>
    </header>
  )
}
